import { useSearchParams } from "react-router-dom";
import Container from "../shared/Container";

const TOSLink = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <Container containerWith="800px" className="my-10">
      <iframe
        src={`https://spherepay.co/tos?token=${token}`}
        title="Terms of Service"
        width="100%"
        height="800px"
        style={{ border: "none" }}
        allowFullScreen
      />
    </Container>
  );
};

export default TOSLink;
